// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"089add07","455":"b0d7b8e8","977":"4348657f"}[chunkId] + ".chunk.js";
};